import {
  AxiosResponseType,
  OnSubmitDripFormType,
  QuestionAttribute,
} from "./sfd-form.type";
import { checkReCaptcha as getRecaptchaToken } from "./checkReCaptcha";
import { logger } from "@utils/logger";
import { onSuccess } from "./on-success";
import { formatSuccessData } from "./format-success-data";
import { setGoogleConversion } from "./set-google-conversion";
import SPfetch from "@services/SPFetch.class";

export const onSubmitDripForm = async ({
  formData,
  recaptchaRef,
  finalTime,
}: OnSubmitDripFormType) => {
  const recaptchaToken =
    process.env.GATSBY_ENVIRONMENT !== "dev"
      ? await getRecaptchaToken(recaptchaRef)
      : null;

  const {
    firstName,
    lastName,
    email,
    phoneNumber,
    globalProfessionId,
    termsOfServiceAcceptance,
    questions,
    otherProfession,
  } = formData;
  const successData = formatSuccessData(formData, recaptchaToken!);

  let questionsResults = null;

  if (questions && Object.keys(questions).length > 0) {
    questionsResults = Object.fromEntries(
      Object.entries(questions).map(([key, obj]) => {
        if (typeof obj === "object" && obj !== null && "value" in obj) {
          const questionAttribute = obj as QuestionAttribute;
          return [key, questionAttribute.value];
        }
        return [key, ""];
      })
    );
  }

  try {
    const name = `${firstName} ${lastName}`;
    const signupEndpoint = `${process.env.GATSBY_WS_URL}/api/signupSubmit`;
    setGoogleConversion(successData.data.attributes);

    const response = await SPfetch.post(signupEndpoint, successData);
    const responseJson: AxiosResponseType = await response.json();

    onSuccess({
      res: responseJson,
      email,
      name,
      phone: phoneNumber,
      profession: globalProfessionId,
      termsOfServiceAcceptance,
      reqEndTime: finalTime,
      questions: questionsResults,
      otherProfession,
    });
  } catch (error) {
    logger(`helpers::SPFetch::post::${JSON.stringify(error)}`);
  }
};
